import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import MainPage from '../components/Dashboard/MainPage';
import SideMenu from '../components/Dashboard/SideMenu';
import TopBar from '../components/mobile/navigation/TopBar';
import { setUserLoggedIn } from '../features/auth/auth.slice';

const Dashboard = () => {
  const menu = [
    {
      title: 'Home',
      icon: 'fa-house',
    },
    {
      title: 'Analytics',
      icon: 'fa-envelope',
    },
    {
      title: 'Comments',
      icon: 'fa-comment',
    },
    // {
    //   title: 'Messages',
    //   icon: 'fa-message',
    // },
    {
      title: 'Channels',
      icon: 'fa-snowflake',
    },
    {
      title: 'Plan',
      icon: 'fa-calendar-days',
    },
    {
      title: 'API',
      icon: 'fa-gear',
    },
    {
      title: 'Settings',
      icon: 'fa-gear',
    },
  ];
  const [selectedPage, setSelectedPage] = useState(menu[0]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setUserLoggedIn());
  }, [dispatch]);
  return (
    <>
      <div className="md:flex flex-row hidden h-screen w-full">
        <div className="flex-[0.15] border">
          <SideMenu
            menu={menu}
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
          />
        </div>
        <div className="flex-1">
          <MainPage
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
          />
        </div>
      </div>
      <div className="md:hidden block">
        <TopBar
          menu={menu}
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
        />
        <MainPage
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
        />
      </div>
    </>
  );
};

export default Dashboard;
